var _g, _animate, _animate2, _animate3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitchTitan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 109.4,
    y: 77.65,
    width: 280.98,
    height: 280.98,
    rx: 15.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.33,78.52H124.45A14.19,14.19,0,0,0,110.27,92.7V343.58a14.19,14.19,0,0,0,14.18,14.18H375.33a14.19,14.19,0,0,0,14.18-14.18V92.7A14.19,14.19,0,0,0,375.33,78.52Zm13,265.06a13,13,0,0,1-13,13H124.45a13,13,0,0,1-13-13V92.7a13,13,0,0,1,13-13H375.33a13,13,0,0,1,13,13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.33,77.65H124.45a15.07,15.07,0,0,0-15,15V343.58a15.07,15.07,0,0,0,15,15.05H375.33a15.07,15.07,0,0,0,15.05-15.05V92.7A15.07,15.07,0,0,0,375.33,77.65Zm0,278H124.45a12.12,12.12,0,0,1-12.11-12.11V92.7a12.13,12.13,0,0,1,12.11-12.11H375.33A12.13,12.13,0,0,1,387.44,92.7V343.58A12.12,12.12,0,0,1,375.33,355.69Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.69,143.77a11.76,11.76,0,1,0,11.75,11.76A11.76,11.76,0,0,0,176.69,143.77Zm0,19a7.23,7.23,0,1,1,7.23-7.22A7.24,7.24,0,0,1,176.69,162.75Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.69,133.89a2.14,2.14,0,1,0,2.14,2.13,2.13,2.13,0,0,0-2.14-2.13Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.34,143.77a11.76,11.76,0,1,0,11.75,11.76A11.76,11.76,0,0,0,322.34,143.77Zm0,19a7.23,7.23,0,1,1,7.23-7.22A7.23,7.23,0,0,1,322.34,162.75Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06,133.89A2.14,2.14,0,1,0,319.2,136a2.13,2.13,0,0,0-2.14-2.13Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.61,133.89a2.14,2.14,0,1,0,2.14,2.13,2.13,2.13,0,0,0-2.14-2.13Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.69,271.9a11.75,11.75,0,1,0,11.75,11.75A11.75,11.75,0,0,0,176.69,271.9Zm0,19a7.23,7.23,0,1,1,7.23-7.23A7.24,7.24,0,0,1,176.69,290.88Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.39,266.54a2.14,2.14,0,1,0,2.13,2.13,2.13,2.13,0,0,0-2.13-2.13Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,266.54a2.14,2.14,0,1,0,2.13,2.13,2.13,2.13,0,0,0-2.13-2.13Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.69,262a2.14,2.14,0,1,0,2.14,2.14,2.14,2.14,0,0,0-2.14-2.14Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.34,271.9a11.75,11.75,0,1,0,11.75,11.75A11.75,11.75,0,0,0,322.34,271.9Zm0,19a7.23,7.23,0,1,1,7.23-7.23A7.23,7.23,0,0,1,322.34,290.88Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.28,266.54a2.14,2.14,0,1,0,2.14,2.13,2.13,2.13,0,0,0-2.14-2.13Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,266.54a2.14,2.14,0,1,0,2.13,2.13,2.13,2.13,0,0,0-2.13-2.13Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,262a2.14,2.14,0,1,0,2.13,2.14,2.14,2.14,0,0,0-2.13-2.14Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,262a2.14,2.14,0,1,0,2.14,2.14,2.14,2.14,0,0,0-2.14-2.14Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.26,179.69v36.75h-3.39V174l1.79,1.79A5.49,5.49,0,0,1,114.26,179.69Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.87,219.85h3.39V256.6a5.49,5.49,0,0,1-1.6,3.89l-1.79,1.79Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.52,179.69v36.75h3.39V174l-1.78,1.79A5.5,5.5,0,0,0,385.52,179.69Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,219.85h-3.39V256.6a5.5,5.5,0,0,0,1.61,3.89l1.78,1.79Z",
    style: {
      fill: "#231f20"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#777"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.79,341.42a1.16,1.16,0,0,1-.49-.47,20.46,20.46,0,0,1-.1-3.64c0-2.34,0-3.58,0-3.75a.91.91,0,0,1,1.47-.51c.34.3.34.31.36,1.82v1.35h6v-1.34c0-1.23,0-1.36.09-1.53a.84.84,0,0,1,.83-.51.86.86,0,0,1,.86.64c0,.12.05,1.31,0,3.78v3.59l-.12.19a.91.91,0,0,1-1.26.29c-.42-.27-.43-.34-.43-1.89V338.1h-6v1.35c0,1.32,0,1.36-.13,1.54a.91.91,0,0,1-.75.47A1.36,1.36,0,0,1,219.79,341.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.07,341.39a1,1,0,0,1-.48-.51c0-.12,0-1.43,0-3.86v-3.68l.2-.19a.86.86,0,0,1,.82-.29.56.56,0,0,1,.48.25,1.27,1.27,0,0,1,.26.41c.07.26.07,7,0,7.27a1,1,0,0,1-.53.61A.92.92,0,0,1,231.07,341.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.44,341.4A1.17,1.17,0,0,1,234,341a19.65,19.65,0,0,1-.08-3.62,28.8,28.8,0,0,1,.07-3.66,1.52,1.52,0,0,1,.32-.45,1.28,1.28,0,0,1,1.12-.42c.46,0,.65.16,1.26.79l1.11,1.16,1.65,1.71,1.68,1.76.67.7,0-2.75a14.4,14.4,0,0,1,.1-2.91.94.94,0,0,1,1.49-.18.89.89,0,0,1,.19.27c0,.1,0,1.28,0,3.61,0,3.89,0,3.66-.36,4.06a1.3,1.3,0,0,1-.93.44c-.5,0-.81-.12-1.37-.7s-2.59-2.69-2.76-2.88L236.37,336l-.61-.63v5.41l-.11.23a.91.91,0,0,1-.79.49A.85.85,0,0,1,234.44,341.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,341.35a2.61,2.61,0,0,1,.4-5.08c.45-.06,5.44-.06,5.69,0a1.13,1.13,0,0,1,.61.52.87.87,0,0,1,.06.43.92.92,0,0,1-.47.75l-.19.12-2.83,0c-3.2,0-3,0-3.21.43a.73.73,0,0,0,.09.79c.25.33.16.32,3.36.31l2.89,0,.29-.12a2.59,2.59,0,0,0,1.49-1.45,1.87,1.87,0,0,0,.14-.88,1.8,1.8,0,0,0-.14-.87,2.51,2.51,0,0,0-1.54-1.5,21.69,21.69,0,0,0-3.62-.11c-3.79,0-3.55,0-3.84-.41a.69.69,0,0,1-.15-.54c0-.33,0-.35.2-.56a1.2,1.2,0,0,1,.34-.27,34.75,34.75,0,0,1,3.63,0l3.49,0,.47.16a4.46,4.46,0,0,1,1.89,1.24,3.55,3.55,0,0,1,.35.42.5.5,0,0,0,.12.2,4.53,4.53,0,0,1,.52,1.23,4.3,4.3,0,0,1,0,2.05,4.43,4.43,0,0,1-3.26,3.2,16.89,16.89,0,0,1-3.45.1C247.41,341.47,247.39,341.47,247,341.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44,341.43a2,2,0,0,1-.83-.52c-.18-.22-1.26-2.09-2.28-4-.11-.2-.35-.65-.55-1-.91-1.62-1-1.92-1-2.15a.93.93,0,0,1,.83-.92c.51,0,.78.17,1.17.91.58,1.09,3.09,5.64,3.14,5.69s.09-.06.15-.17.18-.34.27-.49l.33-.59c.43-.81,1.35-2.48,1.77-3.22.25-.46.56-1,.69-1.27.37-.69.58-.87,1.05-.87a.87.87,0,0,1,.73.37c.14.17.16.22.16.54v.36l-.48.87c-.43.75-1.47,2.63-2,3.68l-.27.5-.25.45-.25.45c-.05.08-.14.26-.22.4a2.09,2.09,0,0,1-.87.85,1.47,1.47,0,0,1-.67.15A3,3,0,0,1,262.44,341.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.55,341.4a2.86,2.86,0,0,1-1.62-1.25,2.63,2.63,0,0,1,1.95-3.89c.25,0,1.46,0,3.07,0h2.66l.19.15a1.4,1.4,0,0,1,.3.35.91.91,0,0,1-.6,1.31c-.14,0-1.1.05-2.88.05h-2.69l-.17.11a.78.78,0,0,0,.06,1.32c.18.11.23.11,3,.11,3,0,3,0,3.54-.24a2.49,2.49,0,0,0,1.25-1.32,2,2,0,0,0,.17-1,2.45,2.45,0,0,0-1.32-2.15c-.53-.28-.56-.28-4-.28-3,0-3.21,0-3.4-.1a.9.9,0,0,1-.14-1.6l.14-.11h7.14l.4.14a4.51,4.51,0,0,1,2.57,2.16,3.7,3.7,0,0,1,.46,1.8,3.28,3.28,0,0,1-.08,1.12,5.68,5.68,0,0,1-.3.88,3.38,3.38,0,0,1-.57.9,4.48,4.48,0,0,1-2.23,1.47c-.33.1-.48.1-3.47.11A29.32,29.32,0,0,1,270.55,341.4Z"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_titan_switch_blink",
    attributeName: "fill",
    values: "#777;#00ffdc;#777",
    begin: "hinava_random_uuid_titan_switch_hand_out.end+1s",
    end: "hinava_random_uuid_titan_switch_hand_out.end+5.2s;",
    dur: "0.7s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.1,30.85a4.14,4.14,0,0,0,0,8.28A45,45,0,0,1,427,84.06a4.15,4.15,0,0,0,8.29,0A53.27,53.27,0,0,0,382.1,30.85Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,53.65a2.84,2.84,0,1,0,0,5.68,30.86,30.86,0,0,1,30.82,30.82,2.84,2.84,0,1,0,5.68,0A36.54,36.54,0,0,0,376,53.65Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.87,84.06a4.14,4.14,0,1,0,8.28,0,45,45,0,0,1,44.93-44.93,4.14,4.14,0,0,0,0-8.28A53.27,53.27,0,0,0,61.87,84.06Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.67,90.15a2.84,2.84,0,1,0,5.68,0,30.86,30.86,0,0,1,30.82-30.82,2.84,2.84,0,1,0,0-5.68A36.54,36.54,0,0,0,84.67,90.15Z",
    style: {
      fill: "#f26850"
    }
  }), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_titan_switch_beep",
    attributeName: "fill-opacity",
    values: "0;1;0;1;0",
    begin: "hinava_random_uuid_titan_switch_hand_out.end",
    dur: "1s"
  }))), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    transform: "translate(7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168.79,
    cy: 152.51,
    r: 18.45,
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.79,186.45a34.08,34.08,0,1,1,34.07-34.08A34.12,34.12,0,0,1,168.79,186.45Zm0-62.36a28.42,28.42,0,1,0,28.41,28.42A28.51,28.51,0,0,0,168.79,124.09Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320.43,
    cy: 152.51,
    r: 18.45,
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.43,186.45a34.08,34.08,0,1,1,34.08-34.08A34.11,34.11,0,0,1,320.43,186.45Zm0-62.36a28.42,28.42,0,1,0,28.42,28.42A28.51,28.51,0,0,0,320.43,124.09Z",
    style: {
      fill: "#f26850"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,326.11c-2.83-28.82-19.66-33.4-27.88-33.81a8.09,8.09,0,0,1-6.46-4C322.72,276,312.49,273,304,273a22,22,0,0,0-3.1.14h-.67a7.74,7.74,0,0,1-7.41-9.7c6.74-26.39,24-86.73,24-86.73,5.38-16-7.68-27.2-20.61-27.2-7.95,0-15.89,4.31-19.12,14.41L253,244.36a11.21,11.21,0,0,1-10.91,8.08,11.36,11.36,0,0,1-10.91-7.95l-23-71.51c-2.69-11.45-11.45-16.43-20.2-16.43-12.52,0-25.18,10.1-21.28,26.4l24.92,103.43a7.72,7.72,0,0,1-5.66,9.29c-8.08,2-19.8,8.75-21.41,29.63-1.89,25.45,35.69,75.15,43,85.65a7.57,7.57,0,0,1,1.35,3.77l3.77,34.08c.27,4,3.63,6.33,7.67,6.33h94.14c4,0,7.41-2.29,7.68-6.33l3.1-31.38a7,7,0,0,1,1.34-3.64C333.36,403.82,367,359.37,363.93,326.11Z",
    style: {
      fill: "#fcd4c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.42,324.63c-1.62-16.7-7.41-29.5-17.37-38a42,42,0,0,0-21.15-9.57,43.15,43.15,0,0,0-30.57-19.39c7.27-27.47,20.07-72.32,21.28-76.5,3.64-11.31,2-22.62-4.58-31.78-6.87-9.56-18.72-15.49-31-15.49h0c-15.9,0-29,9.7-33.94,25.32,0,.14,0,.14-.14.27l-20.33,67.61L222.79,168.8c-4.31-16.83-18-27.74-35.15-27.74a38.83,38.83,0,0,0-30.17,14.28c-6.87,8.75-9.15,19.79-6.33,31.38l23.17,96.56a42,42,0,0,0-13.47,9.7c-7.14,7.81-11.31,18.31-12.26,31.24-1.88,25,20.48,60.34,42.7,91.45.67.94,1.34,1.88,1.88,2.56l3.64,33a23.42,23.42,0,0,0,23.3,21.28h94.14A23.46,23.46,0,0,0,337.54,451l2.82-29.76.81-1.21C359.22,394.66,382.52,357.22,379.42,324.63Zm-54.27,93.19-3.1,31c-.27,4-3.64,6.33-7.68,6.33H220.23c-4,0-7.4-2.29-7.67-6.33l-3.77-34.48a7.58,7.58,0,0,0-1.35-3.64c-7.14-10.5-44.85-59.93-43-85.52,1.48-20.87,13.33-27.47,21.41-29.49a7.83,7.83,0,0,0,5.66-9.29l-24.92-103.3c-3.9-16.3,8.76-26.4,21.28-26.4,8.75,0,17.51,5,20.2,16.43l23,71.52a11.36,11.36,0,0,0,10.91,7.94A11.1,11.1,0,0,0,253,244.49l24.11-80.4c3.23-10.1,11.17-14.41,19.12-14.41,12.79,0,25.86,11.18,20.61,27.21,0,0-17.24,60.33-24,86.73a7.78,7.78,0,0,0,7.41,9.69h.67a23.72,23.72,0,0,1,3.1-.13c8.35,0,18.72,3,25.59,15.22a7.82,7.82,0,0,0,6.46,4c8.22.4,25.19,4.85,27.88,33.8,3.24,33.27-30.57,78-37.3,87.95A5.8,5.8,0,0,0,325.15,417.82Z",
    style: {
      fill: "#010101"
    }
  }), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_titan_switch_hand_in",
    attributeName: "fill-opacity",
    from: 0,
    to: 1,
    begin: "0.5s;hinava_random_uuid_titan_switch_blink.end+1s",
    dur: "1.5s",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_titan_switch_hand_out",
    attributeName: "fill-opacity",
    from: 1,
    to: 0,
    begin: "hinava_random_uuid_titan_switch_hand_in.end+1s",
    dur: "1s",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchTitan);
export default __webpack_public_path__ + "static/media/switch-titan.909408048a4fcf884c67e7705c279c1d.svg";
export { ForwardRef as ReactComponent };